import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetVideosQuery } from "../../../features/Admin/Videos/videosApi";
import useForm from "../../../components/controls/useForm";
import FormField from "./FormField";
import {
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useGetAssignmentQuery,
} from "../../../features/Admin/Assignments/assignmentsApi";
import { useEffect } from "react";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";

const initializeValues = {
  title: "",
  video_id: "",
  video_title: "",
  totalMark: "",
};
export default function AssignmentForm({ isAddForm }) {
  // *****************************************************DECLARATION START******************************************************************************
  const { assignmentId } = useParams();
  const navigate = useNavigate();

  // REDUX API/SLICE START
  const { data: videos } = useGetVideosQuery();
  const {
    data: assignment,
    isLoading: singleAsnIsLoading,
    isSuccess: singleAsnIsSuccess,
    isError: singleAsnIsError,
  } = useGetAssignmentQuery(assignmentId, { skip: isAddForm }); // Get Single Assignment
  const [
    addAssignment,
    {
      isLoading: addAsnIsLoading,
      isSuccess: addAsnIsSuccess,
      isError: addAsnIsError,
    },
  ] = useAddAssignmentMutation(); // Added new Assignment
  const [
    editAssignment,
    {
      isLoading: editAsnIsLoading,
      isSuccess: editAsnIsSuccess,
      isError: editAsnIsError,
    },
  ] = useEditAssignmentMutation(); // Edit Assignment
  // REDUX API/SLICE END

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initializeValues);
  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************
  useEffect(() => {
    if (addAsnIsSuccess || editAsnIsSuccess) {
      resetForm(initializeValues);
      navigate("/admin/assignments");
    }
  }, [addAsnIsSuccess, editAsnIsSuccess, navigate]); // Only for Add and edit Form
  useEffect(() => {
    if (singleAsnIsSuccess) {
      setValues({
        ...assignment,
      });
    }
  }, [singleAsnIsSuccess]);

  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  const handleCancel = () => {
    navigate("/admin/assignments");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const video = videos.find((v) => v.id == values.video_id);
    isAddForm
      ? addAssignment({ ...values, video_title: video?.title })
      : editAssignment({
          data: { ...values, video_title: video?.title },
          id: assignmentId,
        });
  };
  // *****************************************************HANDLE END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  const formContent =
    addAsnIsLoading || editAsnIsLoading || singleAsnIsLoading ? (
      <Loading />
    ) : (!addAsnIsLoading || !editAsnIsLoading) &&
      (addAsnIsError || editAsnIsError || singleAsnIsError) ? (
      <Error
        header={"System Error !!"}
        message={"Please contract with administrator"}
      />
    ) : (
      <FormField
        isAddForm={isAddForm}
        videos={videos}
        values={values}
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        handleCancel={handleCancel}
      />
    );
  // *****************************************************Decided which part render END******************************************************************************
  return (
    <>
      <div className="lg:pl-[14rem] mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <h1 className="mb-10 text-center lws-section-title">
            {isAddForm ? "Add New Assignments" : "Edit Assignments"}
          </h1>
          <div className="max-w-3xl mx-auto">{formContent}</div>
        </main>
      </div>
    </>
  );
}
